import React from 'react';
import { useTranslate } from 'ra-core';
import { Widget } from '../Widget';
import { useUsersWidgetsData } from '../../../api/hooks/useUsersWidgetsData';

export const UsersWidgets: React.FC = () => {
  const translate = useTranslate();
  const { data } = useUsersWidgetsData();

  const { onboarded, activated, engaged } = data ?? {};

  const activationRate =
    ((activated?.total ?? 0) / (onboarded?.total ?? 0)) * 100;
  const activeThisMonthRate =
    ((engaged?.lastThirtyDays ?? 0) / (activated?.total ?? 0)) * 100;

  const diff =
    (engaged?.lastSevedDays ?? 0) - (engaged?.previousSevenDays ?? 0);
  const formattedDiff = `${diff >= 0 ? '+' : ''}${diff}`;

  if (data)
    return (
      <div className="mb-4 mt-0 grid grid-cols-1 gap-4 md:grid-cols-5">
        <div>
          <Widget
            title={translate('moonstar.dashboard.users.onboarded.title')}
            textPrimary={onboarded?.total ?? 0}
            textSecondary={translate('moonstar.dashboard.users.lastSevenDays', {
              count: onboarded?.lastSevedDays ?? 0,
            })}
            description={translate(
              'moonstar.dashboard.users.onboarded.description'
            )}
          />
        </div>
        <div>
          <Widget
            title={translate('moonstar.dashboard.users.activated.title')}
            textPrimary={activated?.total ?? 0}
            textSecondary={translate('moonstar.dashboard.users.lastSevenDays', {
              count: activated?.lastSevedDays ?? 0,
            })}
            description={translate(
              'moonstar.dashboard.users.activated.description'
            )}
          />
        </div>
        <div>
          <Widget
            title={translate('moonstar.dashboard.users.engaged.title')}
            textPrimary={engaged?.lastSevedDays ?? 0}
            textSecondary={translate(
              'moonstar.dashboard.users.comparedToSevenDaysAgo',
              { diff: formattedDiff }
            )}
            description={translate(
              'moonstar.dashboard.users.engaged.description'
            )}
          />
        </div>
        <div>
          <Widget
            title={translate('moonstar.dashboard.users.activationRate.title')}
            textPrimary={`${activationRate.toFixed(1)}%`}
            textSecondary={`(${activated?.total}/${onboarded?.total})`}
            description={translate(
              'moonstar.dashboard.users.activationRate.description'
            )}
          />
        </div>
        <div>
          <Widget
            title={translate('moonstar.dashboard.users.engagedThisMonth.title')}
            textPrimary={`${activeThisMonthRate.toFixed(1)}%`}
            textSecondary={`(${engaged?.lastThirtyDays}/${activated?.total})`}
            description={translate(
              'moonstar.dashboard.users.engagedThisMonth.description'
            )}
          />
        </div>
      </div>
    );
};
